export const tenant=window.location.hostname.split(".")[0]!=="localhost"?window.location.hostname.split(".")[0]:"bottolitestingaprod";//originiconsulting  viridia

export const tenantType="golf";

export const tenantTypeFirstUpperCase=tenantType.charAt(0).toUpperCase() + tenantType.slice(1);